import { PrimaryButton } from '@fluentui/react';
import * as React from 'react';
import localeService from 'src/dataServices/LocaleService';

interface IAgentCard {
  titleId: string;
  detailId: string;
  buttonId: string;
  hrefId: string;
  imageAltId: string;
  imageName: string;
  textSection: string;
}

const CARDS: IAgentCard[] = [
  {
    titleId: 'NonprofitOffersTitle',
    detailId: 'NonprofitOffersDetail',
    buttonId: 'NonprofitOffersButton',
    hrefId: 'urlOffers',
    imageAltId: 'CopilotAgentCardOffersImageAlt',
    imageName: 'offers.jpg',
    textSection: 'ContactUsFeatures'
  },
  {
    titleId: 'EligibilityTitle',
    detailId: 'EligibilityDetail',
    buttonId: 'EligibilityButton',
    hrefId: 'urlEligibility',
    imageAltId: 'CopilotAgentCardEligibilityImageAlt',
    imageName: 'eligibility.jpg',
    textSection: 'ContactUsFeatures'
  },
  {
    titleId: 'ProgramGuidanceTitle',
    detailId: 'ProgramGuidanceDetail',
    buttonId: 'ProgramGuidanceButton',
    hrefId: 'urlMsLearn',
    imageAltId: 'CopilotAgentCardProgramGuidanceImageAlt',
    imageName: 'program-guidance.jpg',
    textSection: 'ContactUs'
  }
];

export const CopilotAgentCards: React.FC = () => {
  return (
    <div className="copilot-agent-cards">
      <div className="copilot-agent-cards-grid">
        {CARDS.map((card, index) => (
          <div key={index} className="copilot-agent-card card h-100">
            <div className="copilot-agent-card-image-wrapper">
              <img
                alt={localeService.getText('ContactUs', card.imageAltId)}
                className="copilot-agent-card-image"
                src={`${process.env.REACT_APP_IMAGES_URL}/contact-us/${card.imageName}`}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = `${process.env.PUBLIC_URL}/cdn/images/contact-us/${card.imageName}`;
                }}
              />
            </div>
            <div className="copilot-agent-card-body card-body d-flex flex-column">
              <h3 className="copilot-agent-card-title">{localeService.getText(card.textSection, card.titleId)}</h3>
              <p className="copilot-agent-card-detail">{localeService.getText(card.textSection, card.detailId)}</p>
              <div className="mt-auto">
                <PrimaryButton
                  href={localeService.getText('Links', card.hrefId) || '#'}
                  className="copilot-agent-card-btn btn btn-primary"
                >
                  {localeService.getText(card.textSection, card.buttonId)}
                </PrimaryButton>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
